/* eslint-disable prettier/prettier */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useEffect, useState, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableData from "./data/DataTableMaterial";
import SwitchR from "react-switch";
import toast, { Toaster } from "react-hot-toast";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import Alert from "@mui/material/Alert";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import moment from "moment";
// Data
import solicitudTableData from "./data/solicitudTableData";
import {
  getSolicitudesT,
  getCatalogosT,
  getInformacionInicial,
  CreateSolicitud,
  getObtenerSolicitud,
  EliminarSolicitud,
} from "store/solicitudes/solicitudesActions";

import { decargarArchivoClinico } from "store/download/dowloadActions";
import ModalContent from "../../components/ModalContent";
import VerticalTabs from "./tabs";
import FormBusqueda from "./forms/formBusqueda";
import Loading from "../../components/loading";
import { Divider } from "@mui/material";
import brandDark from "assets/images/LogoESF.png";
import { useNavigate } from "react-router-dom";
import SolicitudesBorradas from "./data/solicitudesborradas";
import _ from "lodash";
import { store } from "store/store";

function Solicitudes() {
  //const {permisos} = useSelector((state) => state.roles);
  const usuario = store.getState().login.usuario;
  const { solicitudes, isloadingSolicitudes } = useSelector((state) => state.solicitud);
  const [openModalAdd, setopenModalAdd] = useState(false);
  const [checkavisoprivacidad, setcheckavisoprivacidad] = useState(false);
  const [checkacuerdo, setcheckacuerdo] = useState(false);
  const [openmodalConfirmacion, setopenmodalConfirmacion] = useState(false);
  const [rowSeleccionado, setrowSeleccionado] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const DeleteSolicitud = () => {
    dispatch(EliminarSolicitud(rowSeleccionado, true));
    setopenmodalConfirmacion(false);
    setrowSeleccionado(null);
    ejecutarConsultaSolicitudesBorradas();
  };

  // Función reutilizable para cargar solicitudes (con o sin filtros)
  const loadSolicitudes = (filtros = {}) => {
    getSolicitudesT(dispatch, {
      ...filtros,
      esExpediente: false,
    });
  };

  // Carga inicial al montar el componente
  useEffect(() => {
    loadSolicitudes(); // Sin filtros
    getInformacionInicial(dispatch, false);
    getCatalogosT(dispatch);
  }, []);

  var solicitudesv = _.orderBy(solicitudes, ["fechaAplicacion"], ["desc"]);

  const columnsSolicitudes = useMemo(
    () => [
      ...(usuario.username == "soporte"
        ? [
            {
              accessorKey: "idSolicitud",
              header: "ID_BD",
              size: 30,
            },
          ]
        : []),
      {
        accessorKey: "idSolicitudConsecutivo",
        header: "",
        size: 30,
        Cell: ({ row }) => {
          return solicitudesv.length - row.index;
        },
      },
      {
        accessorKey: "precandidato", //access nested data with dot notation
        header: "Precandidato",
        size: 100,
      },
      {
        accessorKey: "fechaNacimiento",
        header: "Fecha de nacimiento",
        size: 100,
        Cell: ({ row }) => {
          return moment(row.original.fechaNacimiento).format("DD/MM/YYYY");
        },
      },
      {
        accessorKey: "fechaAplicacion", //normal accessorKey
        header: "Fecha de aplicacion",
        Cell: ({ row }) => {
          return moment(row.original.fechaAplicacion).format("DD/MM/YYYY");
        },
      },
      {
        accessorKey: "parentescoCandidato",
        header: "Parentesco",
        size: 150,
      },
      {
        accessorKey: "correoContacto",
        header: "Correo",
        size: 150,
      },
    ],
    [solicitudesv.length]
  );

  const refBorradas = useRef();

  const ejecutarConsultaSolicitudesBorradas = () => {
    if (refBorradas.current) {
      refBorradas.current.ejecutarConsulta();
    }
  };

  const usuarioPermisos = store.getState().login?.usuario?.permisos;
  const VerSolicitud = _.filter(usuarioPermisos, (p) => p.idPermiso == 93);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="primary"
                borderRadius="lg"
                coloredShadow="primary"
                style={{ paddingTop: 10 }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDTypography variant="h6" color="white">
                      Administrar solicitudes
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox textAlign="right"></MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox textAlign="center" mt={3} ml={2} mr={2}>
                <FormBusqueda onSearch={loadSolicitudes} />
                <Divider />
                <MDBox textAlign="center">
                  <MDTypography component="p" variant="button" color="white">
                    <MDTypography
                      component="span"
                      variant="button"
                      fontWeight="bold"
                      color="success"
                    >
                      {solicitudesv.length}
                    </MDTypography>
                    &nbsp;{"Total de solicitudes"}
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                {isloadingSolicitudes ? (
                  <Loading title={"Procesando por favor espere"} />
                ) : (
                  <TableData
                    columns={columnsSolicitudes}
                    data={solicitudesv}
                    showModal={() => {
                      setopenModalAdd(true);
                    }}
                    VerSolicitud={(row, esSolicitud, ids) => {
                      navigate("/detalles", {
                        state: {
                          id: row.idSolicitud,
                          vista: "solicitud",
                          esSolicitud: esSolicitud,
                          idMostrar: ids,
                        },
                      });
                    }}
                    esSolicitud={true}
                    EliminarSolicitud={(row) => {
                      setrowSeleccionado(row);
                      setopenmodalConfirmacion(true);
                    }}
                  />
                )}
                <Divider />
                {VerSolicitud.length == 0 ? null : (
                  <SolicitudesBorradas
                    ref={refBorradas}
                    columns={columnsSolicitudes}
                    esExpediente={false}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <ModalContent
        title={""}
        maxWidth="lg"
        fullWidth={true}
        open={openModalAdd}
        fullScreen={false}
        handleClose={() => {
          setopenModalAdd(false);
        }}
        handleAcept={() => {
          setopenModalAdd(false);
        }}
        textAccept=""
        alert={alert}
        onCloseAlert={() => {}}
      >
        <VerticalTabs
          CrearSolicitud={(dataSolicitud) => {
            CreateSolicitud(dispatch, dataSolicitud);
          }}
        />
      </ModalContent>
      <ModalContent
        title={"Eliminar Solicitud"}
        maxWidth="sm"
        fullWidth={false}
        open={openmodalConfirmacion}
        fullScreen={false}
        handleClose={() => {
          setrowSeleccionado(null);
          setopenmodalConfirmacion(false);
        }}
        handleAcept={() => {
          DeleteSolicitud();
        }}
        textAccept="Aceptar"
      >
        <MDBox>
          <MDTypography variant="button" color="text" fontWeight="regular">
            ¿Realmente desea eliminar esta solicitud?
          </MDTypography>
        </MDBox>
      </ModalContent>
      <Toaster
        toastOptions={{ style: { backgroundColor: "#5873B8", fontSize: 12, color: "white" } }}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Solicitudes;
